// Copyright © 2021 Move Closer
import { Model } from '@movecloser/front-core';
export class Comment extends Model {
    boot() {
        this.modelProperties = [
            'childrenCount', 'content', 'publicationDate', 'creator', 'id', 'parentId', 'replies'
        ];
    }
}
